module.exports = __webpack_public_path__ + "static/media/FeedTime_web_2.c465369a.jpg";